import { FormState } from '../../models';
import { basicInfo } from './basic-info';
import { edgeRlInfo } from './edge-rl-info';
import { edgeRlRadar } from './radar';
import { configureAlarms } from './alarms';
import { dialogActions } from './dialog-actions';
import { EdgeRlLocationCardState } from './models';

export const edgeRlFormState = (state: EdgeRlLocationCardState): FormState => {
    return {
        config: {
            info: {
                id: 'edge-rl-location-config',
                title: 'EDGE-RL Location Configuration',
            },
            sections: [
                basicInfo(state),
                edgeRlInfo(state),
                edgeRlRadar(state),
                configureAlarms(state),
                dialogActions(state),
            ],
        },
    };
};
